export const routes = {
  login: "login",
  register: "register",
  home: "/",
  modules: "/modules",
  moduleInfo: "/module/info",
  lessons: "/lessons",
  lessonInfo: "/lesson/info"
};
